import React from 'react';

// A button label that can change without the button changing size.
//
// Every label the button can ever show is rendered into the same grid cell and
// all but the current one are hidden (visibility, not display), so the button is
// always as wide as its widest label. "Save text" -> "Saving…" -> "Save text"
// no longer makes the row jump.
//
// Labels with a running counter ("Aligning… 17s") pass a sizing template with
// the widest plausible value ("Aligning… 000s") in `sizes`; digits are set in
// tabular figures so 1 and 8 take the same room.
//
//   <button><StableLabel current={busy ? 'Saving…' : 'Save text'}
//                        sizes={['Save text', 'Saving…']} /></button>
export default function StableLabel({ current, sizes = [] }) {
  const all = sizes.includes(current) ? sizes : [current, ...sizes];
  return (
    <span className="stable-label">
      {all.map((text, i) => (
        <span key={i} className="stable-label-item" aria-hidden={text !== current}>
          {text}
        </span>
      ))}
    </span>
  );
}
